export const SATELLITE_MAP_BACKGROUND_TAG = "satellite";
